import React, { lazy, Suspense, useState, useRef } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import { SportModal } from "../../shared/Components/Modal";
import SportSettings from "../GameSettings/SportSettings";
import { getAxios } from "../../shared/Services/commonService";
import { API_SPORT } from "../../utils/api/ApiConstant";
import { useQuery } from "@tanstack/react-query";

const SportsBody = lazy(() => import("./SportsBody"));

const Sports = () => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["sportData"],
    queryFn: async () => await getAxios(API_SPORT),
  });

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    modalTitle: "",
    modalContent: null,
    modalSize: "sm",
  });

  const handleModal = (
    rowData,
    title = "",
    modalContent = SportModal,
    size = "md",
  ) => {
    setIsShow({
      isOpen: true,
      modalContent,
      modalTitle: title,
      rowData,
      modalSize: size,
    });
  };

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <SportsBody
          onGameSetting={(rowData) =>
            handleModal(rowData, "Game setting", SportSettings, "xxl")
          }
          isLoading={isLoading}
          data={data}
          refetch={refetch}
        />
      </Suspense>

      {isShow?.isOpen && (
        <CommonModal
          size={isShow.modalSize}
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              modalSize: "sm",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              fetchData: refetch,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Sports;
